/* eslint-disable */

import { useEffect, useState } from 'react'
import spark from '../../assets/PaymentGateway/spark.svg'
import tick from '../../assets/PaymentGateway/Frame 354190.svg'
import { Button } from '../../Components/ui/button'
import { useLocation, useNavigate } from 'react-router-dom'
import PaymentStatusModal from '../../Components/modals/OneTimePayment'
import { get, post } from '../../http/restservice'
import { Input } from '../../Components/ui/input'
import { AlertCircleIcon, ChevronLeft, FileText, Landmark, ScanLine } from 'lucide-react'
import { messageModalState } from '../../store/Feedback'
import { useRecoilState, useRecoilValueLoadable, useSetRecoilState } from 'recoil'
import { BankDetails } from '../../store/AccountDetailsStore'
import env from '../../env/env'
import { useErrorPopup } from '../../hooks/useErrorPopup'
import { toCurrency } from '../../utils/CurrencyUtil'
import ActionPlanUpiRequest from './ActionPlanUpiRequest'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from '../../Components/ui/alert-dialog'
import OrderOtpVerification from './OrderOtpVerification'
import { userDetailsState } from '../LoginState'
import {
  BankAccountItem,
  PaymentMethodCard,
} from '../../Components/MutualFunds/PaymentSelectionUI'

const MFBasketOneTimePayment = () => {
  const location = useLocation()
  const [paymentPayload, setPaymentPayload] = useState(location?.state?.paymentPayload)
  const [userDetails] = useRecoilState(userDetailsState)

  const clientCode = userDetails ? userDetails?.uid?.split('-')[0] : paymentPayload?.clientCode
  const navigate = useNavigate()
  const { showError, onClose } = useErrorPopup()
  const [upiId, setUpiId] = useState(userDetails?.upiId || '')
  const [isLoading, setIsLoading] = useState(false)
  const setMessageModalState = useSetRecoilState(messageModalState)
  const bankDetailsLoadable = useRecoilValueLoadable(BankDetails)
  const bankDetails = bankDetailsLoadable.state === 'hasValue' ? bankDetailsLoadable.contents : {}
  const isBanksLoading = bankDetailsLoadable.state === 'loading'
  const isBanksError = bankDetailsLoadable.state === 'hasError'
  const [showPaymentRequestPopup, setShowPaymentRequestPopup] = useState(false)
  const [selectedOption, setSelectedOption] = useState('')
  const [paymentStep, setPaymentStep] = useState('method')
  const [bankQuery, setBankQuery] = useState('')
  const [responseString, setResponseString] = useState('')
  const [orderNo, setOrderNo] = useState([])
  const [verifyCheque, setVerifyCheque] = useState(false)
  const [loading, setLoading] = useState(false)
  const [showPaymentModal, setShowPaymentModal] = useState(false)
  const [modalData, setModalData] = useState({})
  const [openOTPPopup, setOpenOTPPopup] = useState(false)
  // Stores only approved mandates from the mandates API response
  const [mandateDetails, setMandateDetails] = useState([])

  const [selectedBank, setSelectedBank] = useState(null)

  // Support multiple bank accounts from API response
  const bankAccountsList = (() => {
    const accounts = []

    // If banks array exists, use it (new API format)
    if (Array.isArray(bankDetails?.banks) && bankDetails?.banks.length > 0) {
      bankDetails.banks.forEach((bank) => {
        accounts.push({
          accountNo: bank.accountNo,
          bankName: bank.bankName,
          ifscCode: bank.ifscCode,
          accountHolderName: bank.accountHolderName || bankDetails?.accountHolderName,
        })
      })
    }
    // Fallback to single bank account (backward compatibility)
    else if (bankDetails?.accountNo) {
      accounts.push({
        accountNo: bankDetails.accountNo,
        bankName: bankDetails.bankName,
        ifscCode: bankDetails.ifscCode,
        accountHolderName: bankDetails.accountHolderName,
      })
    }

    return accounts
  })()

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }, [])

  useEffect(() => {
    getMandateDetails()
  }, [paymentPayload?.lumpsumAmount])

  useEffect(() => {
    const onPopState = () => {
      setPaymentStep('method')
    }
    window.addEventListener('popstate', onPopState)
    return () => window.removeEventListener('popstate', onPopState)
  }, [])

  useEffect(() => {
    if (paymentStep !== 'details') return
    if (bankAccountsList.length === 1 && !selectedBank) {
      setSelectedBank(bankAccountsList[0].accountNo)
    }
  }, [paymentStep, bankDetailsLoadable.state, selectedBank, bankAccountsList.length])

  const primaryBankName = bankDetails?.bankName?.toUpperCase() || ''
  const primaryIfsc = bankDetails?.ifscCode?.toUpperCase() || ''

  const disableNetBanking =
    primaryBankName?.includes('DBS') ||
    primaryBankName?.includes('DEVELOPMENT BANK OF SINGAPORE') ||
    primaryBankName?.includes('DIGI BANK') ||
    primaryIfsc?.startsWith('DBSS')


  // useEffect(() => {
  //   openPaymentModal({
  //     onContinue: '/dashboard', // or any other route or function
  //     onRetry: handleRetryPayment,
  //     status: 'inprogress', // possible values: "inprogress", "success", "failed", etc.
  //     loading: true,
  //     paymentData: {
  //       amount: toCurrency(paymentPayload?.lumpsumAmount),
  //       paymentMode: 'Net-Banking',
  //       date: new Date().toLocaleDateString('en-IN', {
  //         day: '2-digit',
  //         month: 'short',
  //         year: 'numeric',
  //         hour: '2-digit',
  //         minute: '2-digit',
  //       }),
  //     },
  //   })
  // }, [])

  const handlePaymentMode = (option) => {
    if (option !== selectedOption) {
      setSelectedBank(null)
      setBankQuery('')
    }
    setSelectedOption(option)
  }

  const goToDetailsStep = () => {
    if (!selectedOption) return
    window.history.pushState({ fabitsPaymentStep: 'details' }, '')
    setPaymentStep('details')
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const handleHeaderBack = () => {
    if (paymentStep === 'details') {
      window.history.back()
      return
    }
    navigate(-1)
  }

  const openPaymentModal = (data) => {
    setModalData(data)
    setShowPaymentModal(true)
  }

  const closePaymentModal = () => {
    setShowPaymentModal(false)
    setModalData({})
    setLoading(false)
  }

  const paymentStatus = async (orders) => {
    try {
      const payload = {
        clientCode,
        orderNo: orderNo,
        isBasketOrder: true,
        customerBasketInvestmentIds: paymentPayload?.basketIds,
      }

      const response = await post('/mutualfundservice/api/bseStar/mfUpload/paymentStatus', payload)

      if (response.isError) {
        setMessageModalState({
          message: response?.response?.message,
          severity: 'error',
        })
      }

      if (
        (!response.isError &&
          response.status === 'SUCCESS' &&
          response.data !== 'PAYMENT NOT INITIATED FOR GIVEN ORDER') ||
        response.data === 'APPROVED ( UPI )'
      ) {
        setShowPaymentRequestPopup(false)

        openPaymentModal({
          onContinue: '/dashboard', // or any other route or function
          status: 'success', // possible values: "inprogress", "success", "failed", etc.
          paymentData: {
            amount: toCurrency(paymentPayload?.lumpsumAmount),
            paymentMode: 'UPI', // could be "Credit Card", "UPI", etc.
            date: new Date().toLocaleDateString('en-IN', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
            }),
          },
        })

        // onOpen('openActionPlanPopup', {
        //   severity: 'success',
        //   title: '',
        //   message:
        //     'Your UPI payment has been successfully processed. The amount has been debited from your account and credited to the recipient.',
        //   severity: 'success',
        //   redirectTo: '/dashboard/mutual-funds/orders',
        //   goBack: '/dashboard',
        // })
      }

      if (
        !response.isError &&
        response.status === 'SUCCESS' &&
        response.data === 'PAYMENT NOT INITIATED FOR GIVEN ORDER'
      ) {
        setShowPaymentRequestPopup(false)

        openPaymentModal({
          onContinue: '/dashboard', // or any other route or function
          onRetry: handleRetryPayment,
          status: 'inprogress', // possible values: "inprogress", "success", "failed", etc.
          paymentData: {
            amount: toCurrency(paymentPayload?.lumpsumAmount),
            paymentMode: 'UPI', // could be "Credit Card", "UPI", etc.
            date: new Date().toLocaleDateString('en-IN', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
            }),
          },
        })

        // showError(
        //   'UPI Payment Failed',
        //   'Payment Failed. Unfortunately, your UPI transaction could not be completed. Please try again or use an alternate payment method.',
        //   () => navigate(-1),
        // )
      }
    } catch (error) {
      console.log('🚀 ~ paymentStatus ~ error:', error)

      openPaymentModal({
        onContinue: '/dashboard', // or any other route or function
        onRetry: handleRetryPayment,
        status: 'failure', // possible values: "inprogress", "success", "failed", etc.
        paymentData: {
          amount: toCurrency(paymentPayload?.lumpsumAmount),
          paymentMode: 'UPI',
          date: new Date().toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          }),
        },
      })
    }
  }

  const oneTimeOrderPayment = async () => {
    try {
      setIsLoading(true)

      const orderNumber = paymentPayload?.orders?.map((order) => order?.orderNumber)

      setOrderNo(orderNumber)

      const totalAmount = paymentPayload?.orders?.reduce(
        (acc, order) => acc + Number(order.orderVal),
        0,
      )

      if (selectedOption === 'UPI' && !upiId) {
        showError('Missing UPI ID', 'Please enter a valid UPI ID to proceed.')
        setIsLoading(false)
        return
      }

      // Require user to choose which bank account is being used
      // (UPI id is linked to a specific bank account as well)
      if (!selectedBank) {
        showError('Select bank account', 'Please select the bank account to proceed.')
        setIsLoading(false)
        return
      }

      const payload = {
        orderNumber,
        totalAmount,
        clientCode,
        accountNo: selectedBank,
        bankName: bankAccountsList?.find((bank) => bank.accountNo === selectedBank)?.bankName,
        ifscCode: bankAccountsList?.find((bank) => bank.accountNo === selectedBank)?.ifscCode,
      }

      if (selectedOption === 'UPI') {
        payload.upiId = upiId
        payload.modeOfPayment = 'UPI'
        payload.loopbackURL = ''
        payload.isFirstTimePaymentUsingUPI = userDetails?.upiId ? false : userDetails?.upiId === upiId ? false : true
      } else if (selectedOption === 'Cheque') {
        payload.modeOfPayment = 'CHEQUE'
        payload.loopbackURL = `${env.LOOPBACK_URL}dashboard/actionplan/one-time-payment/status`
      } else if (selectedOption === 'OTM') {
        payload.modeOfPayment = 'OTM'
        payload.loopbackURL = `${env.LOOPBACK_URL}dashboard/actionplan/one-time-payment/status`
      } else {
        payload.modeOfPayment = 'DIRECT'
        payload.loopbackURL = `${env.LOOPBACK_URL}dashboard/actionplan/one-time-payment/status`
      }

      const response = await post(
        `${env.API_URL}mutualfundservice/api/bseStar/api/oneTimePayment?newVersion=true`,
        payload,
      )

      setIsLoading(false)

      if (response.isError) {
        openPaymentModal({
          onContinue: '/dashboard', // or any other route or function
          onRetry: handleRetryPayment,
          status: 'failure', // possible values: "inprogress", "success", "failed", etc.
          paymentData: {
            amount: toCurrency(paymentPayload?.lumpsumAmount),
            paymentMode: 'Net Banking',
            date: new Date().toLocaleDateString('en-IN', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
            }),
          },
        })

        // showError(
        //   selectedOption !== 'UPI' ? 'Payment Failed' : 'UPI Payment Failed',
        //   'Payment could not be processed at the moment. Please try later.',
        //   () => {},
        // )
      }

      if ((response?.status === 'SUCCESS') & (selectedOption === 'UPI')) {
        // onOpen('openPopup', {
        //   message: response.data.responsestring,
        //   severity: 'success',
        //   callback,
        // })
        setShowPaymentRequestPopup(true)
      }

      if (
        response?.status === 'SUCCESS' &&
        selectedOption !== 'UPI' &&
        selectedOption !== 'Cheque' &&
        payload.modeOfPayment !== 'UPI' &&
        response?.data?.responsestring
      ) {
        setResponseString(response?.data?.responsestring)
        // openBankPaymentResponse(response?.data?.responsestring)
        localStorage.setItem(
          'actionPlanPaymentStatusData',
          JSON.stringify({
            response: response?.data?.responsestring,
            clientCode,
            orderNo: orderNumber,
            basketIds: paymentPayload?.basketIds,
            amount: paymentPayload?.lumpsumAmount,
          }),
        )
        navigate('/dashboard/one-time-payment/status', {
          state: {
            response: response?.data?.responsestring,
            clientCode,
            orderNo: orderNumber,
          },
        })
      }

      if (
        response?.status === 'SUCCESS' &&
        selectedOption == 'Cheque' &&
        payload.modeOfPayment === 'CHEQUE' &&
        response?.message?.includes('One-time payment will be processed using cheque')
      ) {
        openPaymentModal({
          onContinue: '/dashboard', // or any other route or function
          onRetry: handleRetryPayment,
          status: 'inprogress', // possible values: "inprogress", "success", "failed", etc.
          paymentData: {
            amount: toCurrency(paymentPayload?.lumpsumAmount),
            paymentMode: 'Cheque | RTGS | NEFT',
            date: new Date().toLocaleDateString('en-IN', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
            }),
          },
        })



        // onOpen('openActionPlanPopup', {
        //   severity: 'info',
        //   title: 'Your order has been placed',
        //   message: 'Your Relationship Manager will stay in touch with you.',
        //   redirectTo: '/dashboard',
        //   goBack: '/dashboard',
        // })
        return
      }


      if (
        response?.status === 'SUCCESS' &&
        selectedOption == 'OTM' &&
        payload.modeOfPayment === 'OTM' &&
        response?.message?.includes('One-time payment will be processed using cheque or otm')
      ) {
        openPaymentModal({
          onContinue: '/dashboard', // or any other route or function
          onRetry: handleRetryPayment,
          status: 'inprogress', // possible values: "inprogress", "success", "failed", etc.
          paymentData: {
            amount: toCurrency(paymentPayload?.lumpsumAmount),
            paymentMode: 'OTM',
            date: new Date().toLocaleDateString('en-IN', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
            }),
          },
        })



        // onOpen('openActionPlanPopup', {
        //   severity: 'info',
        //   title: 'Your order has been placed',
        //   message: 'Your Relationship Manager will stay in touch with you.',
        //   redirectTo: '/dashboard',
        //   goBack: '/dashboard',
        // })
        return
      }

      if (response?.status === 'FAILURE') {
        // showError(
        //   selectedOption !== 'UPI' ? 'Payment Failed' : 'UPI Payment Failed',
        //   response.data.responsestring,
        //   () => navigate(-1),
        // )

        openPaymentModal({
          onContinue: '/dashboard', // or any other route or function
          onRetry: handleRetryPayment,
          status: 'failure', // possible values: "inprogress", "success", "failed", etc.
          paymentData: {
            amount: toCurrency(paymentPayload?.lumpsumAmount),
            paymentMode: 'Net Banking',
            date: new Date().toLocaleDateString('en-IN', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
            }),
          },
        })
      }

      if (response.isError) {
        // showError(
        //   selectedOption !== 'UPI' ? 'Payment Failed' : 'UPI Payment Failed',
        //   response.data.responsestring,
        //   () => navigate(-1),
        // )

        openPaymentModal({
          onContinue: '/dashboard', // or any other route or function
          onRetry: handleRetryPayment,
          status: 'failure', // possible values: "inprogress", "success", "failed", etc.
          paymentData: {
            amount: toCurrency(paymentPayload?.lumpsumAmount),
            paymentMode: selectedOption,
            date: new Date().toLocaleDateString('en-IN', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
            }),
          },
        })
      }
    } catch (error) {
      console.log('🚀 ~ placeOneTimeOrder ~ error:', error)
      openPaymentModal({
        onContinue: '/dashboard', // or any other route or function
        onRetry: handleRetryPayment,
        status: 'failure', // possible values: "inprogress", "success", "failed", etc.
        paymentData: {
          amount: toCurrency(paymentPayload?.lumpsumAmount),
          paymentMode: 'Net Banking',
          date: new Date().toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          }),
        },
      })
    }
  }

  const handleRetryPayment = async (payload) => {
    try {
      setLoading(true)

      const response = await post(
        'mutualfundservice/api/basket/multiBasketOneTimeOrder',
        location?.state?.orderPayload,
      )

      if (response.isError) {
        closePaymentModal()
        setLoading(false)
        showError('', 'Unable to process your orders at this time. Please try again', () => { })
        return
      }

      if (response.status === 'SUCCESS') {
        const failures = response.basketResponses
          .map((response) => {
            const failedOrders = response?.orders?.filter((order) => order.status === 'FAILURE') || []
            return failedOrders.length > 0 ? { ...response, orders: failedOrders } : null
          })
          ?.filter((response) => response !== null)

        if (failures.length) {
          setLoading(false)
          showError('', 'Unable to process your orders at this time. Please try again', () => { })
          return
        }

        const basketIds = location?.state?.orderPayload?.map(
          (basket) => basket.customerBasketInvestmentId,
        )

        const orders =
          response?.basketResponses?.length > 0
            ? response?.basketResponses?.flatMap((basket) => basket?.orders || [])
            : []

        sessionStorage.setItem('oneTimeActionPlanOrders', JSON.stringify(orders))

        const lumpsumAmount = location?.state?.paymentPayload?.lumpsumAmount

        const paymentPayload = {
          clientCode: clientCode?.toUpperCase(),
          orders: orders,
          lumpsumAmount: lumpsumAmount,
          basketIds: basketIds,
        }

        setPaymentPayload(paymentPayload)
        setLoading(false)
        closePaymentModal()
      } else {
        closePaymentModal()
        setLoading(false)
        showError('Try again later.', response?.response, () => { })
      }
    } catch (error) {
      closePaymentModal()
      console.log('🚀 ~ placeOneTimeRetryOrder ~ error:', error)
      setLoading(false)
      showError('', 'Unable to process your orders at this time. Please try again', () => { })
    }
  }

  const getMandateDetails = async () => {
    const response = await get('mutualfundservice/api/mutualFund/mandates')

    const approved =
      response?.status === 'SUCCESS' && Array.isArray(response?.data)
        ? response.data.filter((m) => m?.mandateStatus === 'APPROVED')
        : []

    setMandateDetails(approved)
  }

  const generateOTP = async () => {
    const response = await post(
      `${env.API_URL}mutualfundservice/api/mutualFund/sendTransactionalOtp`,
      {
        phoneNumber: userDetails?.phoneNumber,
        email: userDetails?.email,
      },
    )

    if (response.isError) {


      showError('OTP Error', 'Failed to generate OTP. Please try again later.', () => { })
    }

    if (!response.isError) {


      setOpenOTPPopup(true)
    }
  }


  const shouldShowOTMOption =
    Array.isArray(mandateDetails) &&
    mandateDetails.length > 0 &&
    mandateDetails.some((m) => Number(m?.amount) >= Number(paymentPayload?.lumpsumAmount))

  const showUpiOption = Number(paymentPayload?.lumpsumAmount) <= 200000
  const filteredBankAccounts = bankAccountsList.filter((bank) => {
    const query = bankQuery.trim().toLowerCase()
    if (!query) return true
    return (
      bank.bankName?.toLowerCase().includes(query) ||
      bank.accountHolderName?.toLowerCase().includes(query) ||
      bank.accountNo?.slice(-4)?.includes(query)
    )
  })
  const showBankSearch = selectedOption === 'NetBanking' && bankAccountsList.length > 2

  const detailsCopy = {
    UPI: {
      title: 'UPI Payment',
      subtitle: 'Select your bank account',
      cta: 'Continue to UPI',
    },
    NetBanking: {
      title: 'Select your bank',
      subtitle: 'Choose the linked account you will pay from',
      cta: 'Continue',
    },
    Cheque: {
      title: 'Cheque / RTGS / NEFT',
      subtitle: 'Select the account you will use to transfer funds',
      cta: 'Continue',
    },
    OTM: {
      title: 'One Time Mandate',
      subtitle: 'Select the account to debit',
      cta: 'Continue',
    },
  }[selectedOption] || {
    title: 'Payment',
    subtitle: 'Select an account',
    cta: 'Continue',
  }

  const canContinueDetails =
    Boolean(selectedBank) && (selectedOption !== 'UPI' || Boolean(upiId?.trim()))

  const handleDetailsContinue = () => {
    if (selectedOption === 'Cheque') {
      setVerifyCheque(true)
      return
    }
    if (selectedOption === 'OTM') {
      generateOTP()
      return
    }
    oneTimeOrderPayment()
  }


  return (
    <>
      {showPaymentRequestPopup ? (
        <ActionPlanUpiRequest
          bankDetails={bankDetails}
          setShowPaymentRequestPopup={setShowPaymentRequestPopup}
          paymentStatus={paymentStatus}
          handleRetry={() =>
            openPaymentModal({
              onContinue: '/dashboard', // or any other route or function
              onRetry: handleRetryPayment,
              status: 'failure', // possible values: "inprogress", "success",
              // "failed", etc.
              paymentData: {
                amount: toCurrency(paymentPayload?.lumpsumAmount),
                paymentMode: 'UPI',
                date: new Date().toLocaleDateString('en-IN', {
                  day: '2-digit',
                  month: 'short',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                }),
              },
            })
          }
        />
      ) : (
        <div className='bg-white fabits-payment-page'>
          <div className='min-h-screen fabits-payment-shell'>
            <button
              type='button'
              className='flex gap-x-1 items-center font-semibold cursor-pointer lg:py-2.5 p-4 bg-white fabits-payment-header w-full text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500'
              onClick={handleHeaderBack}
            >
              <ChevronLeft className='h-5 w-5' />
              Payment
            </button>

            <div className='flex items-start justify-center w-full fabits-payment-body'>
              <div className='w-full max-w-[360px] px-1 fabits-payment-panel'>
                <h1 className='font-dm-sans text-base font-medium leading-6 text-center fabits-payment-kicker'>
                  Investment amount
                </h1>
                <p className='font-dm-sans text-[32px] font-semibold leading-[42px] tracking-[-0.04em] text-center mt-2 mb-8 fabits-payment-amount'>
                  ₹ {toCurrency(paymentPayload?.lumpsumAmount)}
                </p>

                {paymentStep === 'method' ? (
                  <div className='flex flex-col gap-4 fabits-payment-methods'>
                    <h2 className='font-dm-sans text-base font-semibold leading-6 text-left text-black-500'>
                      How would you like to pay?
                    </h2>

                    <div
                      role='radiogroup'
                      aria-label='How would you like to pay?'
                      className='flex flex-col gap-4'
                    >
                      {showUpiOption && (
                        <PaymentMethodCard
                          id='UPI'
                          selected={selectedOption === 'UPI'}
                          onSelect={handlePaymentMode}
                          icon={
                            <ScanLine
                              className={selectedOption === 'UPI' ? 'text-primary-500' : 'text-[#727272]'}
                            />
                          }
                          title='UPI'
                          supportingText='Fastest · Up to ₹1 Lakh'
                          showFastest
                          sparkIcon={spark}
                        />
                      )}

                      {!disableNetBanking && (
                        <PaymentMethodCard
                          id='NetBanking'
                          selected={selectedOption === 'NetBanking'}
                          onSelect={handlePaymentMode}
                          icon={
                            <Landmark
                              className={
                                selectedOption === 'NetBanking' ? 'text-primary-500' : 'text-[#727272]'
                              }
                            />
                          }
                          title='Net Banking'
                          supportingText='Higher payment limits'
                        />
                      )}

                      <PaymentMethodCard
                        id='Cheque'
                        selected={selectedOption === 'Cheque'}
                        onSelect={handlePaymentMode}
                        icon={
                          <FileText
                            className={selectedOption === 'Cheque' ? 'text-primary-500' : 'text-[#727272]'}
                          />
                        }
                        title='Cheque / RTGS / NEFT'
                        supportingText='Higher payment limits'
                      />

                      {shouldShowOTMOption && (
                        <PaymentMethodCard
                          id='OTM'
                          selected={selectedOption === 'OTM'}
                          onSelect={handlePaymentMode}
                          icon={
                            <FileText
                              className={selectedOption === 'OTM' ? 'text-primary-500' : 'text-[#727272]'}
                            />
                          }
                          title='One Time Mandate'
                          supportingText='Higher payment limits'
                        />
                      )}
                    </div>

                    <Button
                      disabled={!selectedOption}
                      className='w-full mt-4 py-3 px-4 rounded-[12px] bg-[#41558d] disabled:bg-primary-300 font-dm-sans text-[14px] font-medium leading-[20px] text-white fabits-payment-proceed'
                      onClick={goToDetailsStep}
                    >
                      Continue
                    </Button>
                  </div>
                ) : (
                  <div className='flex flex-col gap-6 fabits-payment-methods'>
                    <div className='flex flex-col gap-1'>
                      <h2 className='font-dm-sans text-xl font-semibold leading-7 text-left fabits-payment-option-title text-black-500'>
                        {detailsCopy.title}
                      </h2>
                      <p className='font-dm-sans text-sm font-medium leading-5 text-black-300 fabits-payment-helper'>
                        {detailsCopy.subtitle}
                      </p>
                    </div>

                    {selectedOption === 'Cheque' && (
                      <p className='font-dm-sans text-sm font-medium leading-5 text-black-300 fabits-payment-note'>
                        After you continue, share cheque, NEFT or RTGS details with your relationship manager.
                      </p>
                    )}

                    {selectedOption === 'OTM' && (
                      <p className='flex items-start gap-2 font-dm-sans text-[13px] font-medium leading-[18px] text-left text-warning-600 py-2'>
                        <AlertCircleIcon className='w-5 h-5 shrink-0 text-warning-600' />
                        <span>
                          Your money will be debited automatically within the next 2 working days.
                        </span>
                      </p>
                    )}

                    {showBankSearch && (
                      <div>
                        <label htmlFor='bank-search' className='sr-only'>
                          Search bank
                        </label>
                        <Input
                          id='bank-search'
                          value={bankQuery}
                          onChange={(e) => setBankQuery(e.target.value)}
                          type='text'
                          placeholder='Search bank'
                          className='fabits-payment-upi-input'
                        />
                      </div>
                    )}

                    {isBanksLoading && (
                      <p className='font-dm-sans text-sm text-black-300 fabits-payment-helper'>
                        Loading linked bank accounts…
                      </p>
                    )}

                    {isBanksError && (
                      <p className='font-dm-sans text-sm text-error-600' role='alert'>
                        Unable to load bank accounts. Please try again.
                      </p>
                    )}

                    {!isBanksLoading && !isBanksError && bankAccountsList.length === 0 && (
                      <p className='font-dm-sans text-sm text-black-300 fabits-payment-helper' role='status'>
                        No linked bank accounts found.
                      </p>
                    )}

                    {!isBanksLoading && bankAccountsList.length > 0 && (
                      <div role='radiogroup' aria-label='Select bank account' className='flex flex-col gap-3'>
                        {filteredBankAccounts.length === 0 ? (
                          <p className='font-dm-sans text-sm text-black-300 fabits-payment-helper'>
                            No banks match your search.
                          </p>
                        ) : (
                          filteredBankAccounts.map((bank) => (
                            <BankAccountItem
                              key={bank.accountNo}
                              bank={bank}
                              isSelected={selectedBank === bank.accountNo}
                              onSelect={setSelectedBank}
                              tickIcon={tick}
                              bankLogosUrl={env.BANK_LOGOS}
                            />
                          ))
                        )}
                      </div>
                    )}

                    {selectedOption === 'UPI' && (
                      <div className='flex flex-col gap-2'>
                        <label
                          htmlFor='upi-id'
                          className='font-dm-sans text-[14px] font-medium leading-[20px] text-black-500 fabits-payment-label'
                        >
                          UPI ID
                        </label>
                        <Input
                          id='upi-id'
                          value={upiId}
                          onChange={(e) => setUpiId(e.target.value)}
                          type='text'
                          placeholder='address@bank'
                          autoComplete='off'
                          className='fabits-payment-upi-input'
                          aria-describedby='upi-limit-note'
                        />
                        <p
                          id='upi-limit-note'
                          className='font-dm-sans text-sm font-medium leading-5 text-black-300 fabits-payment-note'
                        >
                          Some banks may have lower transaction limits. If UPI fails, you can switch to Net Banking.
                        </p>
                      </div>
                    )}

                    <Button
                      disabled={!canContinueDetails}
                      loading={isLoading}
                      className='w-full mt-2 py-3 px-4 rounded-[12px] bg-[#41558d] disabled:bg-primary-300 font-dm-sans text-[14px] font-medium leading-[20px] text-white fabits-payment-proceed'
                      onClick={handleDetailsContinue}
                    >
                      {detailsCopy.cta}
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <AlertDialog open={verifyCheque} onOpenChange={setVerifyCheque}>
        <AlertDialogContent className='h-auto min-h-[240px]'>
          <AlertDialogHeader>
            <AlertDialogTitle>Cheque, NEFT & RTGS</AlertDialogTitle>
            <AlertDialogDescription className='text-black-400'>
              Please ensure you have sent your cheque/NEFT/RTGS details to your relationship
              manager.
              <br />
              <br />
              Contact us at <strong>+91 8050034800</strong>
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={() => oneTimeOrderPayment()}>Continue</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      <PaymentStatusModal
        isOpen={showPaymentModal}
        onClose={closePaymentModal}
        onContinue={modalData.onContinue}
        onRetry={modalData.onRetry}
        status={modalData.status}
        loading={loading}
        paymentData={modalData.paymentData}
      />

      {openOTPPopup && (
        <OrderOtpVerification
          phoneNumber={userDetails?.phoneNumber}
          openOTPPopup={openOTPPopup}
          setOpenOTPPopup={setOpenOTPPopup}
          email={userDetails?.email}
          handleSipOrOT={oneTimeOrderPayment}
        />
      )}
    </>
  )
}

export default MFBasketOneTimePayment
